import type { AlpineComponent } from 'alpinejs'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

export function ScrollingGrid(): AlpineComponent<{
  init(): void
}> {
  gsap.registerPlugin(ScrollTrigger)

  return {
    init() {
      const sections: HTMLElement[] = gsap.utils.toArray(
        this.$el.querySelectorAll('.scoll-grid-item'),
      )
      let mm = gsap.matchMedia()

      // don't animate the last section
      sections.pop()

      sections.forEach((section) => {
        const image = section.querySelector('.scroll-grid-fixed')
        mm.add('(min-width: 768px)', () => {
          ScrollTrigger.create({
            trigger: section,
            start: 'top top',
            end: 'bottom top',
            pin: image,
            pinSpacing: false,
          })
        })
      })
    },
  }
}
